"use client";

import { type ReactNode } from "react";

export default function GlobalError(): ReactNode {
  return <p>Root Error Page</p>;
}
